import { CoveredOptionName } from "@covertree/new-business-graphql";

const coverageOptionDetails = {
  [CoveredOptionName.AircraftAndMotorVehiclesCollision]: {
    title: "Aircraft and Motor Vehicles Collision",
    icon: "/images/plan-icons/aircraftAndMotorVehiclesCollision.webp",
  },
  [CoveredOptionName.BadWeather]: {
    title: "Bad Weather",
    icon: "/images/plan-icons/weather.webp",
  },
  [CoveredOptionName.BurglaryTheftVandalism]: {
    title: "Vandalism and Theft",
    icon: "/images/plan-icons/vandalismTheft.webp",
  },
  [CoveredOptionName.Earthquake]: {
    title: "Earthquake",
    icon: "/images/plan-icons/earthquake.webp",
  },
  [CoveredOptionName.Electronics]: {
    title: "Electronics",
    icon: "/images/plan-icons/electronics.webp",
  },
  [CoveredOptionName.FireSmokeAndExplosion]: {
    title: "Fire, Smoke, and Explosion",
    icon: "/images/plan-icons/fireSmokeExplosion.webp",
  },
  [CoveredOptionName.Flood]: {
    title: "Flood",
    icon: "/images/plan-icons/water.webp",
  },
  [CoveredOptionName.Lawsuits]: {
    title: "Lawsuits",
    icon: "/images/plan-icons/lawsuits.webp",
  },
  [CoveredOptionName.NeglectAndIntentionalLoss]: {
    title: "Neglect and Intentional Loss",
    icon: "/images/plan-icons/neglectAndIntentionalLoss.webp",
  },
  [CoveredOptionName.OrdinanceOrLaw]: {
    title: "Ordinance or Law",
    icon: "/images/plan-icons/ordinanceOrLaw.webp",
  },
  [CoveredOptionName.PowerFailure]: {
    title: "Power Failure",
    icon: "/images/plan-icons/powerFailure.webp",
  },
  [CoveredOptionName.Precipitation]: {
    title: "Precipitation",
    icon: "/images/plan-icons/precipitation.webp",
  },
  [CoveredOptionName.RiotCivilCommotion]: {
    title: "Riot/Civil Commotion",
    icon: "/images/plan-icons/vandalismTheft.webp",
  },
  [CoveredOptionName.ToolsAndEquipment]: {
    title: "Tools and Equipment",
    icon: "/images/plan-icons/toolsAndEquipment.webp",
  },
  [CoveredOptionName.Valuables]: {
    title: "Valuables",
    icon: "/images/plan-icons/valuables.webp",
  },
  [CoveredOptionName.VandalismAndTheft]: {
    title: "Vandalism and Theft",
    icon: "/images/plan-icons/vandalismTheft.webp",
  },
  [CoveredOptionName.WarAndNuclearHazard]: {
    title: "War and Nuclear Hazard",
    icon: "/images/plan-icons/warNuclearHazard.webp",
  },
  [CoveredOptionName.WaterDamage]: {
    title: "Water Damage",
    icon: "/images/plan-icons/water.webp",
  },
};

const coveredTooltips: Partial<
  Record<keyof typeof CoveredOptionName, JSX.Element>
> = {
  [CoveredOptionName.BadWeather]: (
    <>Losses caused by lightning, tornado, windstorm.</>
  ),
  [CoveredOptionName.Electronics]: (
    <>
      Up to $1,000 for loss of cameras, DVD players, computers (including their
      hardware and software), other electronic equipment.
    </>
  ),
  [CoveredOptionName.FireSmokeAndExplosion]: (
    <>Losses from all fires, smoke, and explosions.</>
  ),
  [CoveredOptionName.OrdinanceOrLaw]: (
    <>
      Policies cover costs of updating your house to ensure it meets current
      building codes.
    </>
  ),
  [CoveredOptionName.Precipitation]: (
    <>
      Losses caused by rain, snow, sleet, sand or dust when entering through a
      wind created opening.
    </>
  ),
  [CoveredOptionName.ToolsAndEquipment]: <>Up to $1,000 on tools.</>,
  [CoveredOptionName.Valuables]: (
    <>
      Cover theft up to:
      <br />
      - $1,000 for jewelry, precious stones
      <br />
      - $1,000 for silverware
      <br />
      - $1,000 for memorabilia, and souvenirs
      <br />- $1,000 for fine arts, antiques
    </>
  ),
  [CoveredOptionName.VandalismAndTheft]: (
    <>
      Stolen items or damage caused by riots, vandalism, malicious mischief,
      motor vehicles owned or operated by someone other than you.
    </>
  ),
  [CoveredOptionName.WaterDamage]: (
    <>
      Losses caused by accidental discharge, overflow of water or steam, pipe
      burst.
    </>
  ),
  [CoveredOptionName.Lawsuits]: (
    <>
      Provide you a defense attorney of our choice, coverage for bodily injury
      or property damage damages for which you are legally liable, covers dog
      bites up to $10,000.
    </>
  ),
  [CoveredOptionName.AircraftAndMotorVehiclesCollision]: (
    <>
      Aircraft and/or motor vehicle collisions where you are not operating the
      vehicle are covered. Damage to fences, driveways, and sidewalks are not
      covered.
    </>
  ),
  [CoveredOptionName.RiotCivilCommotion]: (
    <>Damage caused by riots or other civil commotion are covered.</>
  ),
};

const notCoveredTooltips: Partial<
  Record<keyof typeof CoveredOptionName, JSX.Element>
> = {
  [CoveredOptionName.NeglectAndIntentionalLoss]: (
    <>
      Lack of maintenance, abusive use, and a failure to take reasonable steps
      to save and preserve property are not covered. Intentional loss, including
      arson, is not covered.
    </>
  ),
  [CoveredOptionName.Flood]: (
    <>
      A flood is an excess of water on land that is normally dry (e.g. storm
      surge, surface flooding). You can buy this coverage separately from
      another provider.
    </>
  ),
  [CoveredOptionName.Earthquake]: (
    <>
      Most of homeowners insurance does not cover earthquake damage. Earthquake
      coverage may be available to you as an optional coverage.
    </>
  ),
  [CoveredOptionName.WarAndNuclearHazard]: (
    <>
      War and nuclear incident is a large enough disaster that insurance
      coverage is the least of one&apos;s worries. There is, at this time, no
      coverage available in any market for personal lines coverage for these
      hazards.
    </>
  ),
  [CoveredOptionName.OrdinanceOrLaw]: (
    <>
      Policies do not cover costs of updating your house to ensure it meets
      current building codes. Ordinance or Law is covered for modular homes
      because they are built to local building codes instead of the national HUD
      code.
    </>
  ),
  [CoveredOptionName.PowerFailure]: (
    <>
      Policies do not cover service interruption due to power outages and losses
      arising from an interruption of utility services.
    </>
  ),
  [CoveredOptionName.WaterDamage]: (
    <>
      Losses caused by accidental discharge, overflow of water or steam, pipe
      burst are not covered.
    </>
  ),
  [CoveredOptionName.VandalismAndTheft]: (
    <>Stolen items, vandalism, or other malicious mischief is not covered.</>
  ),
  [CoveredOptionName.BurglaryTheftVandalism]: (
    <>Stolen items, vandalism, or other malicious mischief is not covered.</>
  ),
};

export function getCoveredItemDetails(
  value: CoveredOptionName,
  isCovered: boolean
) {
  const { title, icon } = coverageOptionDetails[value];

  return {
    description: isCovered ? coveredTooltips[value] : notCoveredTooltips[value],
    title,
    icon,
  };
}
